/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StrapiBlockFromJSON, StrapiBlockToJSON, } from './StrapiBlock';
/**
 * Check if a given object implements the ContactComponent interface.
 */
export function instanceOfContactComponent(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
export function ContactComponentFromJSON(json) {
    return ContactComponentFromJSONTyped(json, false);
}
export function ContactComponentFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'title': json['title'] == null ? undefined : json['title'],
        'text': json['text'] == null ? undefined : (json['text'].map(StrapiBlockFromJSON)),
        'id': json['id'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'firstNameRequired': json['firstNameRequired'] == null ? undefined : json['firstNameRequired'],
        'lastNameRequired': json['lastNameRequired'] == null ? undefined : json['lastNameRequired'],
        'emailRequired': json['emailRequired'] == null ? undefined : json['emailRequired'],
        'firstNameLabel': json['firstNameLabel'] == null ? undefined : json['firstNameLabel'],
        'lastNameLabel': json['lastNameLabel'] == null ? undefined : json['lastNameLabel'],
        'emailLabel': json['emailLabel'] == null ? undefined : json['emailLabel'],
    };
}
export function ContactComponentToJSON(json) {
    return ContactComponentToJSONTyped(json, false);
}
export function ContactComponentToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'title': value['title'],
        'text': value['text'] == null ? undefined : (value['text'].map(StrapiBlockToJSON)),
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'firstNameRequired': value['firstNameRequired'],
        'lastNameRequired': value['lastNameRequired'],
        'emailRequired': value['emailRequired'],
        'firstNameLabel': value['firstNameLabel'],
        'lastNameLabel': value['lastNameLabel'],
        'emailLabel': value['emailLabel'],
    };
}
